exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-pane__header {\n  flex-flow: row-reverse;\n  justify-content: space-between;\n  height: 100%;\n  padding-top: 2rem;\n  padding-right: 1rem;\n}\n\n.slide-pane__title-wrapper {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  margin-left: 32px;\n  min-width: 0;\n  align-self: start;\n}\n\n.slide-pane__close {\n  align-self: start;\n}\n\n.slide-pane .slide-pane__title {\n  padding-top: 8px;\n}\n", ""]);

// exports
